import { Routes, Route } from "react-router-dom";
import Header from "./components/App/Header";
import Dashboard from "./components/Pages/Dashboard";

import {
  GlobalStateProvider,
  useGlobalState,
} from "./components/Context/GlobalStateContext";

import LoadingAnimation from "./components/LoadingAnimation/LoadingAnimation";


function App() {
  const globalState = useGlobalState();

  return (
    <main>
      {globalState.ShowAnimation && <LoadingAnimation />}
      <div className="App--main">
        <Header />
        <div className="Body--Main">
          <Routes>
            <Route
              path=""
              element={
                  <Dashboard />

              }
            />
          </Routes>
        </div>
      </div>

    </main>
  );
}

export default App;
